import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { ISegmentedProps, SegmentedValue } from 'components/uiKit/Segmented'
import Segmented from 'components/uiKit/Segmented'

const FieldSegmented = <V extends SegmentedValue>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<ISegmentedProps<V>, V>) => {
  const handleChange = useCallback((value: V) => onChange({ name, value }), [name, onChange])

  return <Segmented {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldSegmented) as typeof FieldSegmented
